import { useTheme } from '@mui/material';
const useCustomAvatarStyles = () => {
    const theme = useTheme();
    return {
        avatarOutterContainerStyles: {
            display: 'flex',
            width: 40,
            height: 40,
            padding: '2px',
            alignItems: 'flex-start',
            borderRadius: '50px',
            border: `2px solid ${theme.palette.action.hover}`
        },
        avatarContentContainerStyles: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: '1 0 0',
            alignSelf: 'stretch',
            borderRadius: '500px',
            background: theme.palette.background.neutral,
            overflow: 'hidden'
        },
        profileImageStyles: {
            width: '100%',
            height: 'auto',
            objectFit: 'cover'
        },
    };
};
export default useCustomAvatarStyles;
